import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Cars from "@/pages/Cars";
import CarDetail from "@/pages/CarDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Expenses from "@/pages/Expenses";
import Calendar from "@/pages/Calendar";
import Sales from "@/pages/Sales";
import Users from "@/pages/Users";
import Todos from "@/pages/Todos";
import Backups from "@/pages/Backups";
import EmployeeExpenses from "@/pages/EmployeeExpenses";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="flex h-screen items-center justify-center text-slate-400">
        Se încarcă...
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AdminOnly({ children }) {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/cars" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CurrencyProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Protected>
                  <Layout />
                </Protected>
              }
            >
              <Route index element={<AdminOnly><Dashboard /></AdminOnly>} />
              <Route path="cars" element={<Cars />} />
              <Route path="cars/:id" element={<CarDetail />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="expenses" element={<AdminOnly><Expenses /></AdminOnly>} />
              <Route path="sales" element={<Sales />} />
              <Route path="calendar" element={<Calendar />} />
              <Route path="todos" element={<Todos />} />
              <Route path="employee-expenses" element={<AdminOnly><EmployeeExpenses /></AdminOnly>} />
              <Route path="reminders" element={<Navigate to="/calendar" replace />} />
              <Route path="users" element={<AdminOnly><Users /></AdminOnly>} />
              <Route path="backups" element={<AdminOnly><Backups /></AdminOnly>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        </CurrencyProvider>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
